import { Check, TriangleAlert, X } from 'lucide-react';
import { useSafety, useMonitoring } from '@/store/selectors';
import { ToxicityRisk } from '@/types';

/** Toxicity risk display with trough-minimization workflow (PSD §8.2 / TODO Task 2.19). */
export function ToxicityRecheck(): JSX.Element | null {
  const safety = useSafety();
  const monitoring = useMonitoring();

  if (!safety) return null;

  const riskClass =
    safety.toxicityRisk === ToxicityRisk.High ? 'badge-danger'
    : safety.toxicityRisk === ToxicityRisk.Moderate ? 'badge-warn'
    : 'badge-safe';

  const riskIcon =
    safety.toxicityRisk === ToxicityRisk.High ? <X size={12} strokeWidth={2.5} aria-hidden="true" />
    : safety.toxicityRisk === ToxicityRisk.Moderate ? <TriangleAlert size={12} strokeWidth={2} aria-hidden="true" />
    : <Check size={12} strokeWidth={2.5} aria-hidden="true" />;

  return (
    <section className="panel panel-result" aria-label="Toxicity and recheck" data-testid="toxicity-recheck">
      <h2 className="panel-title">Toxicity &amp; Recheck</h2>
      <div className="value-row">
        <span className="value-label">Toxicity risk</span>
        <span className={`badge ${riskClass}`}>{riskIcon}{safety.toxicityRisk.toUpperCase()}</span>
      </div>

      {safety.toxicityRiskFactors.length > 0 && (
        <div className="safety-section">
          <strong>Risk factors:</strong>
          <ul className="bullet-list">
            {safety.toxicityRiskFactors.map((rf, i) => (
              <li key={i}>{rf}</li>
            ))}
          </ul>
        </div>
      )}

      {monitoring?.troughMinimizationTarget != null && (
        <div className="value-row" title="Extended-interval target: keep trough below this level to minimize accumulation and toxicity.">
          <span className="value-label">Trough minimization target</span>
          <span className="value-num">
            &lt; {monitoring.troughMinimizationTarget} mg/L
          </span>
        </div>
      )}

      {safety.nonOverridableCaution && (
        <div className="badge badge-warn">
          <TriangleAlert size={12} strokeWidth={2} aria-hidden="true" />
          {safety.cautionReason}
        </div>
      )}
    </section>
  );
}
